import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["impersonateButton"];

  connect() {
    setTimeout(() => this.impersonateButtonTarget.disabled = false, 400);
  }
}
